import { type Attachment as GQLItem, AttachmentStatusEnum as GQLAttachmentStatusEnum } from '../../generated/graphql';
import { take } from '../../util';
import { z } from 'zod';

export const AttachmentStatus = Object.freeze({
  PENDING: 'pending',
  UPLOADING: 'uploading',
  READY: 'ready',
  FAILED: 'failed',
});

export type AttachmentStatus = (typeof AttachmentStatus)[keyof typeof AttachmentStatus];

export const attachmentSchema = z.object({
  id: z.number().optional(),
  name: z.string(),
  mime: z.string(),
  size: z.number(),
  checksum: z.string().optional(),
  status: z.nativeEnum(AttachmentStatus).optional(),
  url: z.string().url().optional(),
});

export type Attachment = z.infer<typeof attachmentSchema>;

export const gqlStatusMap = {
  [GQLAttachmentStatusEnum.Pending]: AttachmentStatus.PENDING,
  [GQLAttachmentStatusEnum.Uploading]: AttachmentStatus.UPLOADING,
  [GQLAttachmentStatusEnum.Ready]: AttachmentStatus.READY,
};

export const fromGql = (gqlItem: GQLItem): Attachment => ({
  ...take<Attachment>(gqlItem, 'id', 'name', 'mime', 'size', 'checksum', 'url'),
  status: gqlItem.status ? gqlStatusMap[gqlItem.status] : undefined,
});
